export default [
	{
		path: '/holiday',
		name: 'holiday',
		component: () => import('@/views/holiday/index.vue'),
		meta: {
			resource: 'Home',
			pageTitle: 'Administrar Personalizados'
		},
	}

]
